module.exports = "static/assets/32d903cafc72328bd30afce14bfa4c79.svg";